<template>
	<div class="baoHu">
	
	  <div class="wenti">
	    <div>
	      <el-row>
	        <el-col :span="6">
	          <img src="../../images/yinsi_img1.jpg"/>
	        </el-col>
	        <el-col :span="6">
	          <span>
	            酒店偷拍
	          </span>
	          <p>
	            酒店安置针孔摄像头偷拍进行牟利已经成为一个黑色产业链，通过对摄像头进行伪装后，安装在隐蔽之处，随着摄像头技术的成熟，成本不断降低，这让偷拍逐渐成为了一种小投入高回报的行为，且此违法行为极具特殊性和隐蔽性。
	          </p>
	        </el-col>
	        <el-col :span="6">
	          <span>
	            手机APP
	          </span>
	          <p>
	            升降式前置摄像头作为现代手机的一大卖点，在日常使用时，前置摄像头隐藏在机身顶部，当需要自拍时，前置摄像头会自动升起，退出自拍时，前置摄像头也会自动降回机身，显得非常炫酷。一些拥有相机权限的App会在用户不知情的情况下，不定时偷拍周围的环境。严重侵犯用户隐私。
	          </p>
	        </el-col>
	        <el-col :span="6">
	          <img src="../../images/yinsi_img2.jpg"/>
	        </el-col>
	      </el-row>
	
	      <ul>
	        <li>
	          <p>
	            隐蔽收集用户个人信息
	          </p>
	          <p>
	            超出用户心理预期获取个人信息
	          </p>
	        </li>
	        <li>
	          <span>
	            典型问题
	          </span>
	        </li>
	        <li>
	          <p>
	            误导用户同意收集个人信息
	          </p>
	          <p>
	            第三方SDK存在安全风险
	          </p>
	        </li>
	      </ul>
	    </div>
	  </div>
	
	  <div class="fangan">
	    <div>
	      个人隐私安全仍有许多争议问题，需要社会各界多方参与，做好个人信息利用与安全之间的平衡，确定个人隐私信息收集使用的相关标准和尺度，合理界定违法违规行为，避免”一刀切“的做法妨碍移动互联网的创新发展，目前河北司法鉴定中心可承接软件应用是否存在泄漏个人隐私行为鉴定及与个人隐私安全相关的鉴定服务，并出具司法鉴定中心鉴定报告具有司法效力。
	    </div>
	  </div>
	</div>
</template>

<script>
	import axios from 'axios'
	import '../assets/css/baoHu.less'
	export default {
		name: 'index',
		data() {
			return {
				
			}
		},
		methods: {
			
		},
		components: {
			
		},
		computed: {},
		watch: {
		},
		created() {
		}
	};
</script>

<style lang="less">
	
</style>
